import React from 'react'
import appApi from '../../classes/appApi'
import generateContextProvider from '../../shared/hooks/GenerateContextProvider'
import { useBaseConfigContext } from './AppBaseConfig'
import { useDeploymentContext } from './AppDeploymentProvider'

export { AppTenantlessApiProvider, useTenantlessApiContext, useTenantlessApiContextOptional } from './AppTenantlessApi'

/** Tenanted API: requires `useDeploymentContext()` (inside `AppDeploymentProvider` tenanted branch). */
//@todo - move appApi here
const ApiWrapper = (props: {
    provider: React.FC<{ value: appApi; children: React.ReactNode }>
    children: React.ReactNode
}) => {
    const ApiProvider = props.provider

    const config = useBaseConfigContext()
    const { tenantID, environment, instance, organisationURLPrefix } = useDeploymentContext()

    const api = new appApi({
        config: config.api,
        tenantUrlPrefix: organisationURLPrefix,
        tenantID: tenantID,
        environment: environment,
        instance: instance,
    })

    return <ApiProvider value={api}>{props.children}</ApiProvider>
}

const {
    ContextProvider: AppApiProvider,
    useContext: useApiContext,
    useContextOptional: useApiContextOptional,
} = generateContextProvider<appApi>(undefined, ApiWrapper)

export { AppApiProvider as default, useApiContext, useApiContextOptional }
